export const CREATIVE_REPORT_ID = 'creative';
